import { createFileRoute } from '@tanstack/react-router'
import { SellerList } from '@/features/sellers/pages/seller-list'

export const Route = createFileRoute('/_authenticated/sellers/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <SellerList />
}
